// TODO: Translations
export const errorMessage = "We are sorry but we cannot fulfill this query.";
export const buttonLabel = "Try again";
